function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "63.999",
  zoomAndPan: "magnify",
  viewBox: "0 0 47.999 15.136",
  height: "20.182",
  preserveAspectRatio: "xMidYMid",
  version: "1.0",
  id: "svg19",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("defs", {
  id: "defs5"
}, /*#__PURE__*/React.createElement("clipPath", {
  id: "08da024eee"
}, /*#__PURE__*/React.createElement("path", {
  d: "M585.523 121h1194.75v377.836H585.523zm0 0",
  clipRule: "nonzero",
  id: "path2"
}))), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#08da024eee)",
  id: "g17",
  transform: "matrix(.04018 0 0 .04018 -23.524 -4.88)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M824.355 350.04v48.12c-24.84 9.39-52.91 14.086-84.207 14.086-103.086 0-154.625-49.785-154.625-149.355 0-94.29 51.54-141.434 154.625-141.434 31.297 0 59.368 4.691 84.207 14.082v48.125c-24.84-10.762-51.64-16.14-80.394-16.14-68.852 0-103.277 31.788-103.277 95.367 0 68.855 34.425 103.285 103.277 103.285 28.754 0 55.555-5.38 80.394-16.137zm100.641 61.323L844.31 199.801h56.332l53.109 151.41 51.93-151.41h55.457l-87.438 216.847c-15.453 38.145-40.195 65.336-74.23 81.57l-25.82-36.382c23.472-10.367 40.585-27.191 51.347-50.473zm216.531-1.172l-80.39-210.39h56.332l51.054 147.008L1221.63 199.8h56.039l-85.379 210.39zm161.375-286.683h53.106V410.19h-53.106zm98.293 237.68h53.106v49.003h-53.106zm88.313-16.43c0-41.863 30.418-62.797 91.25-62.797 14.281 0 28.656 1.371 43.133 4.11v-15.848c0-18.973-13.594-28.461-40.786-28.461-23.082 0-48.605 3.324-76.578 9.976v-41.96c27.973-6.653 53.496-9.977 76.578-9.977 62.594 0 93.891 23.082 93.891 69.25v141.14h-30.809l-19.07-18.78c-18.191 12.519-38.34 18.78-60.441 18.78-51.446 0-77.168-21.812-77.168-65.433zm134.383-22.598c-13.497-2.738-27.875-4.105-43.133-4.105-25.426 0-38.14 8.703-38.14 26.113 0 18.781 10.66 28.172 31.98 28.172 17.605 0 34.035-5.578 49.293-16.727zm103.277-198.652h53.11v41.96h-53.11zm0 76.293h53.11v210.39h-53.11zm0 0",
  fillOpacity: "1",
  fillRule: "nonzero",
  id: "path15"
}))));